/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckoutFullfillmentShippings200ResponseAllOfData } from './GetCheckoutFullfillmentShippings200ResponseAllOfData';
import {
    GetCheckoutFullfillmentShippings200ResponseAllOfDataFromJSON,
    GetCheckoutFullfillmentShippings200ResponseAllOfDataFromJSONTyped,
    GetCheckoutFullfillmentShippings200ResponseAllOfDataToJSON,
} from './GetCheckoutFullfillmentShippings200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckoutFullfillmentShippings200Response
 */
export interface GetCheckoutFullfillmentShippings200Response {
    /**
     * 
     * @type {GetCheckoutFullfillmentShippings200ResponseAllOfData}
     * @memberof GetCheckoutFullfillmentShippings200Response
     */
    data: GetCheckoutFullfillmentShippings200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCheckoutFullfillmentShippings200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCheckoutFullfillmentShippings200Response interface.
 */
export function instanceOfGetCheckoutFullfillmentShippings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCheckoutFullfillmentShippings200ResponseFromJSON(json: any): GetCheckoutFullfillmentShippings200Response {
    return GetCheckoutFullfillmentShippings200ResponseFromJSONTyped(json, false);
}

export function GetCheckoutFullfillmentShippings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckoutFullfillmentShippings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckoutFullfillmentShippings200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCheckoutFullfillmentShippings200ResponseToJSON(value?: GetCheckoutFullfillmentShippings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckoutFullfillmentShippings200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

